<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/repair/acceptance/order/joinPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujuweixiudanhao')">
            <el-input v-model="yt.conditions.repairNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')" prop="moldId">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.moldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('weixiuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('daichuli')" :value="0"></el-option>
              <el-option :label="$t('chulizhong')" :value="1"></el-option>
              <el-option :label="$t('yiwancheng')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('songxiuleixing')">
            <yi_dictionary_select :max="1" clearable type="MOULD_REPAIR_TYPE" :ids.sync="yt.conditions.repairType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')">
            <el-select v-model="yt.conditions.level">
              <el-option :label="$t('yiban')" :value="0"></el-option>
              <el-option :label="$t('jinji')" :value="1"></el-option>
              <el-option :label="$t('teji')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('oaAuditStatus')">
            <yi_dictionary_select :max="1" clearable type="OA_AUDIT_STATUS" :ids.sync="yt.conditions.oaAuditStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('yanshouzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_ACCEPTANCE_STATUS'" :ids.sync="yt.conditions.acceptanceStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #jinjichengdu="scope">
        <template v-if="scope.row.level == 0">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #909399;"></span>
            <span style="margin-left: 5px;">{{ $t('yiban') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 1">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #E6A23C;"></span>
            <span style="margin-left: 5px;">{{ $t('jinji') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 2">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #F56C6C;"></span>
            <span style="margin-left: 5px;">{{ $t('teji') }}</span>
          </div>
        </template>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_mold_management_repair_acceptance_order_accept') && scope.row.status == 2 && scope.row.acceptanceStatus == 0">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('jianyan', scope.row, 'w1');
                showDeal(scope.row);
              "
            >
              {{ $t('jianyan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item :label="$t('weixiudanhao')" label-width="150px" required>
          <el-input v-model="acceptData.no" disabled> </el-input>
        </el-form-item>

        <el-form-item :label="$t('weixiujishi')" label-width="150px">
          <el-input v-model="acceptData.nickname" disabled> </el-input>
        </el-form-item>

        <el-form-item :label="$t('shenheshijian')" label-width="150px">
          <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="acceptData.acceptanceTime"></yi_time_input>
        </el-form-item>

        <el-form-item :label="$t('yanshoujieguo')" label-width="150px" required>
          <yi_dictionary_select :type="'ACCEPTANCE_RESULTS'" :ids.sync="acceptData.acceptanceResult"> </yi_dictionary_select>
        </el-form-item>

        <el-form-item :label="$t('shifouchaoqi')" label-width="150px">
          <el-select v-model="acceptData.overdueFlag">
            <el-option :label="$t('fou')" value="0"></el-option>
            <el-option :label="$t('shi')" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('shimocishu')" label-width="150px">
          <el-input v-model="acceptData.trialNum"> </el-input>
        </el-form-item>

        <el-form-item :label="$t('beizhu')" label-width="150px">
          <el-input type="textarea" max="400" v-model="acceptData.remark"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="store.state.global_loading" size="mini" @click="accept()" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-新增' } }">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
const date = new Date();
export default {
  name: 'web_mould_repair_acceptance_order',
  data() {
    return {
      acceptData: {},
      columns: [
        {
          label: 'mujuweixiudanhao',
          prop: 'repairNo',
          fixed: 'left'
        },
        {
          label: 'mujubianhao',
          prop: 'mold.no'
        },
        {
          label: 'mujubianma',
          prop: 'mold.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mold.name'
        },
        {
          label: 'songxiuleixing',
          prop: 'repairType',
          type: 'dictionary',
          key: 'MOULD_REPAIR_TYPE'
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'slot'
        },
        {
          label: 'shenqingren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'miaoshu',
          prop: 'faultDescription'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            1: {
              color: '#E6A23C',
              text: this.$t('chulizhong')
            },
            2: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
            // 4: {
            // 	color: '#969696',
            // 	text: this.$t('shibai')
            // }
          }
        },
        {
          label: 'weixiushifu',
          prop: 'repairer'
        },
        {
          label: 'kaishiweixiuren',
          prop: 'startRepairerObject.nickname'
        },
        {
          label: 'yujiwanchengshijian',
          prop: 'expectedEndTime',
          type: 'time',
          width: 160
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'yanshouzhuangtai',
          prop: 'acceptanceStatus',
          type: 'tag',
          tags: {
            '0': {
              color: '#E6A23C',
              text: this.$t('daiyanshou')
            },
            '1': {
              color: '#67C23A',
              text: this.$t('yiyanshou')
            },
            '2': {
              color: '#F56C6C',
              text: this.$t('yanshouweitongguo')
            }
          }
        },
        {
          label: 'jianyanshijian',
          prop: 'acceptanceTime',
          type: 'time'
        },
        {
          label: 'yanshoujieguo',
          prop: 'acceptanceResult'
        },
        {
          label: 'shifouchaoqi',
          prop: 'overdueFlag',
          type: 'tag',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('shi')
            },
            0: {
              color: '#67C23A',
              text: this.$t('fou')
            }
          }
        },
        {
          label: 'shimocishu',
          prop: 'trialNum'
        },
        {
          label: 'jianyanbumen',
          prop: 'acceptanceOrgObject.name'
        },
        {
          label: 'yanshouren',
          prop: 'acceptanceByObject.nickname'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  methods: {
    showDeal(row) {
      this.acceptData.repairId = row.id;
      this.acceptData.acceptanceTime = date.getTime();
      this.acceptData.no = row.repairNo;
      this.acceptData.nickname = row.repairer;
    },
    accept() {
      this.http
        .post('/web/mould/repair/acceptance/order/accept', this.acceptData)
        .then(res => {
          this.acceptData = {};
          this.yt.isShowEditDialog = false;
          this.$message.success(this.$t('success'));
          this.yt.get(1);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    exportExcel() {
      this.http.get('/web/mould/repair/acceptance/order/joinPage?page=1&pageSize=10000', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => {
          if (i.label != 'caozuo' && i.label != 'tupian') {
            return this.$t(i.label);
          }
        });
        let filterFirst = tableFirst.filter(item => {
          if (item) {
            return item;
          }
        });
        console.log('tableFirst', filterFirst);
        let tableData = [];
        tableData.push(filterFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i]);
          tableData.push(dataArr);
        }
        console.log('tableArr', tableData);
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具维修验收单-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      });
    },
    getTableDataArr(row) {
      console.log(row);
      let dataArr = [];
      dataArr[0] = row.repairNo;
      dataArr[1] = row.mold && row.mold.no;
      dataArr[2] = row.mold && row.mold.code;
      dataArr[3] = row.mold && row.mold.name;
      console.log(row.repairType);
      if (row.repairType != null) {
        switch (row.repairType) {
          case 0:
            console.log(this.$t('xiumu'));
            dataArr[4] = this.$t('xiumu');
            break;
          case 1:
            console.log(this.$t('gaimu'));
            dataArr[4] = this.$t('gaimu');
            break;
          case 2:
            console.log(this.$t('pinmu'));
            dataArr[4] = this.$t('pinmu');
            break;
          case 3:
            console.log(this.$t('huanjiegou'));
            dataArr[4] = this.$t('huanjiegou');

            break;
          case 4:
            console.log(this.$t('shengchanzhongweixiu'));
            dataArr[4] = this.$t('shengchanzhongweixiu');

            break;
          case 5:
            console.log(this.$t('chanhouweixiu'));
            dataArr[4] = this.$t('chanhouweixiu');

            break;
        }
      }
      if (row.level != null) {
        switch (row.level) {
          case 0:
            dataArr[5] = this.$t('yiban');
            break;
          case 1:
            dataArr[5] = this.$t('jinji');
            break;
          case 2:
            dataArr[5] = this.$t('teji');
            break;
          default:
            dataArr[5] = '';
            break;
        }
      }
      dataArr[6] = row.createByObject && row.createByObject.nickname;
      dataArr[7] = row.faultDescription;
      if (row.status != null) {
        switch (row.status) {
          case 0:
            dataArr[8] = this.$t('daichuli');
            break;
          case 1:
            dataArr[8] = this.$t('chulizhong');
            break;
          case 2:
            dataArr[8] = this.$t('yiwancheng');
            break;
        }
      } else {
        dataArr[8] = '';
      }
      dataArr[9] = row.repairer;
      dataArr[10] = row.repairByObject && row.repairByObject.nickname;
      if (row.acceptanceStatus != null) {
        switch (row.acceptanceStatus) {
          case '0':
            dataArr[11] = this.$t('daiyanshou');
            break;
          case '1':
            dataArr[11] = this.$t('yiyanshou');
            break;
          case '2':
            dataArr[11] = this.$t('yanshouweitongguo');
            break;
        }
      } else {
        dataArr[11] = '';
      }
      dataArr[12] = row.acceptanceTime && this.dayjs(row.acceptanceTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[13] = row.acceptanceResult;
      if (row.overdueFlag != null) {
        switch (row.overdueFlag) {
          case 0:
            dataArr[14] = this.$t('shi');
            break;
          case 1:
            dataArr[14] = this.$t('fou');
            break;
        }
      } else {
        dataArr[14] = '';
      }
      dataArr[15] = row.trialNum;
      dataArr[16] = row.acceptanceOrgObject && row.acceptanceOrgObject.name;
      dataArr[17] = row.acceptanceByObject && row.acceptanceByObject.nickname;
      dataArr[18] = row.remark;
      return dataArr;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'desc'
      };
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style lang="scss" scoped>
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>
